
import {isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet, isSafari } from 'react-device-detect';

import * as constants from '../constants';

import {localStorageTTL, getLocalStorage, setLocalStorage} from './localStorageWithTTL';

function getBrowserType() {
    const test = regexp => {
        return regexp.test(navigator.userAgent);
    };

    //console.log(navigator.userAgent);

    if (test(/opr\//i) || !!window.opr) {
        return 'Opera';
    } else if (test(/edg/i)) {
        return 'Microsoft Edge';
    } else if (test(/chrome|chromium|crios/i)) {
        return 'Google Chrome';
    } else if (test(/firefox|fxios/i)) {
        return 'Mozilla Firefox';
    } else if (test(/safari/i)) {
        return 'Apple Safari';
    } else if (test(/trident/i)) {
        return 'Microsoft Internet Explorer';
    } else if (test(/ucbrowser/i)) {
        return 'UC Browser';
    } else if (test(/samsungbrowser/i)) {
        return 'Samsung Browser';
    } else {
        return 'Unknown browser';
    }
}

const openAppOrStoreAndroid = (_fallbackURL="") => {
    // create intent url
    // load intent url
    // if fail make fallback to open _fallbackURL url

    var pathNames = window.location.pathname.split("/");
    var mid = pathNames[1];
    //var Deep_Link_URI = pathNames[2];

    var dl_data = getLocalStorage("DL_Meta_Data");

    //console.log("dl_data", dl_data);

    var Push_Type = dl_data?.Push_Type || "";
    var Post_ID = dl_data?.Post_ID || "";
    var Deep_Link_URI = dl_data?.Deep_Link_URI || "";
    var User_TokenKey = dl_data?.User_TokenKey || "";
    var User_ID = dl_data?.User_ID || "";

    var Ads_ID = dl_data?.Ads_ID || "";
    var Advertiser_ID = dl_data?.Advertiser_ID || "";
    var Place_Id = dl_data?.Place_Id || "";

    var Meta_Title = dl_data?.Meta_Title || "";
    var Meta_Image = dl_data?.Meta_Image || "";
    var Meta_Description = dl_data?.Meta_Description || "";

    // Push_Type=9
    // &Post_ID=45463
    // &Deep_Link_URI=5e6zr4rrlwucyvx8k
    // &User_TokenKey=g7j5vaqjas58qqbzelvatx25n1713782611498
    // &User_ID=1689
    // &Ads_ID=
    // &Advertiser_ID=
    // &Place_Id=    

    // "User_ID": "6",
    // "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e",
    // "Deep_Link_URI": "no0awkvxatlx8gmxz",
    // "Push_Type": "1",
    // "Meta_Title": "Dr. Nigam Kr tiwari",
    // "Meta_Image": "1756968728097.jpg",
    // "Meta_Description": "Contact%20us%3A-%208800530116%20%2C%20deekshaojha15%40gmail.com%20%20website%3A-%20www.explurger.com",    

    // const deepLinkParams = "Deep_Link_URI="+Deep_Link_URI;
    // const encodedParams = encodeURIComponent(deepLinkParams);

    // const deepLinkParams = "deeplink=true&Push_Type=<%=data.Push_Type%>&Post_ID=<%=data.Post_ID%>&Deep_Link_URI=<%=data.Deep_Link_URI%>&User_TokenKey=<%=data.User_TokenKey%>&User_ID=<%=data.User_ID%>&Ads_ID=<%=data.Ads_ID%>&Advertiser_ID=<%=data.Advertiser_ID%>&Place_Id=<%=data.Place_Id%>&Meta_Title=<%=data.Meta_Title%>&Meta_Description=<%=data.Meta_Description%>&Meta_Image=<%=data.Meta_Image%>";    

    const deepLinkParams = "deeplink=true&Push_Type="+Push_Type+"&Post_ID="+Post_ID+"&Deep_Link_URI="+Deep_Link_URI+"&User_TokenKey="+User_TokenKey+"&User_ID="+User_ID+"&Ads_ID="+Ads_ID+"&Advertiser_ID="+Advertiser_ID+"&Place_Id="+Place_Id+"&Meta_Title="+Meta_Title+"&Meta_Description="+Meta_Description+"&Meta_Image="+Meta_Image;
    const encodedParams = encodeURIComponent(deepLinkParams);
    
    // APP_DEEP_LINK_BASE_URL

    const intentDomain = new URL(constants.APP_DEEP_LINK_BASE_URL).hostname;

    //console.log("intentDomain", intentDomain); // "www.explurgerdev.com"

    // var intent_url = "intent://"+intentDomain+"/" + mid + "?" + deepLinkParams + "&referrer="+Deep_Link_URI+"#Intent;scheme=https;package=com.explurgerapp;S.browser_fallback_url="+encodeURIComponent(_fallbackURL)+";end";

    // var intent_url = "intent://"+intentDomain+"/" + mid + "?" + deepLinkParams + "&referrer="+Deep_Link_URI+"#Intent;scheme=market;package=com.android.vending;S.browser_fallback_url="+encodeURIComponent(_fallbackURL)+";end";        

    var intent_url = "intent://details?id=com.explurgerapp&url=" + constants.APP_DEEP_LINK_BASE_URL +"/"+ mid + "?" + encodedParams + "&referrer="+Deep_Link_URI+"#Intent;scheme=market;package=com.android.vending;end";

    // var url = "intent://details?id=com.explurgerapp&url=" + Deep_Link_Base_Url + mid + "?" + encodedParams + "&referrer=<%=data.Deep_Link_URI%>#Intent;scheme=market;package=com.android.vending;end";    

    // console.log("Android Intent URL ", mid, intent_url);
    // console.log("Android Intent fallbackUrl ", mid, _fallbackURL);                

      
    // window.location.href = intent_url;

    // // setTimeout(() => {

    // //     console.log("Android 2000 setTimeout:", mid, intent_url, _fallbackURL);

    // //     window.location.href = _fallbackURL;
    
    // // }, 2000);

    // var clickedAt = Date.now();

    // setTimeout(function () {
    //     // If user still on webpage (no app opened),
    //     // cancel Play Store redirect by doing nothing
    //     if (Date.now() - clickedAt < 2000) {

    //         console.log("Android 1500 setTimeout:", mid, intent_url, _fallbackURL);

    //         // override Play Store fallback → stay on same page
    //         //history.replaceState(null, '', window.location.href);
    //         // history.replaceState(null, '', _fallbackURL);

    //         window.location.href = _fallbackURL;
    //         //window.location = _fallbackURL;
    //     }
    // }, 1500); 
    
      setTimeout(() => {
        //console.log("Open URL", intent_url)
        //alert("Open URL")
        if (window.top !== window.self) 
        {
          window.parent.postMessage({ action: "openDeepLink", dl_url: intent_url }, "*");
        }
        else
        {
          window.location = intent_url;
        }        
        //window.location = intent_url;
      }, 10); // 2000 milliseconds = 2 seconds    

};

const getIOSDDLURL = (_browserType, _encodedParams) => {
  var deepLinkUrl = "";
  //console.log("getIOSDDLURL-_browserType, deviceType, isSafari", _browserType, deviceType, isSafari);

  // deepLinkUrl = "com.veensa.Explurger-iOS://" + constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + _encodedParams; // Chrome & Others

  // deepLinkUrl = "com.veensa.Explurger-iOS://https://www.explurger.com/ddl/index.html?" + _encodedParams; // Chrome & Others  

  // https://www.explurgerdev.com

  // if (_browserType == "Apple Safari") {
  //   deepLinkUrl = constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + _encodedParams; // Safari
  //   console.log("Apple URL Safari-deepLinkUrl: ", deepLinkUrl);
  // } else {
  //   deepLinkUrl = "com.veensa.Explurger-iOS://" + constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + _encodedParams; // Chrome & Others
  //   console.log("Apple URL -2 -deepLinkUrl: ", deepLinkUrl);
  // }

  deepLinkUrl = constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + _encodedParams; // Safari
  // console.log("Apple URL any-deepLinkUrl: ", deepLinkUrl);  

  // console.log("getIOSDDLURL-deepLinkUrl", deepLinkUrl);
  return deepLinkUrl;
};

const openAppOrStoreIOS = (_fallbackURL="") => {
    const browserType = getBrowserType();
    var dlAppOpenStatus = 0;
    var dlAppOpen = 0;    

    //var pathNames = window.location.pathname.split("/");
    //var mid = pathNames[1];
    //var Deep_Link_URI = pathNames[2];

    // var profile_data = getLocalStorage("profile_data");

    // console.log("profile_data", profile_data);    

    // const deepLinkParams = "Deep_Link_URI="+Deep_Link_URI;
    // const encodedParams = encodeURIComponent(deepLinkParams);

    var dl_data = getLocalStorage("DL_Meta_Data");

    //console.log("dl_data", dl_data);

    var Push_Type = dl_data?.Push_Type || "";
    var Post_ID = dl_data?.Post_ID || "";
    var Deep_Link_URI = dl_data?.Deep_Link_URI || "";
    var User_TokenKey = dl_data?.User_TokenKey || "";
    var User_ID = dl_data?.User_ID || "";

    var Ads_ID = dl_data?.Ads_ID || "";
    var Advertiser_ID = dl_data?.Advertiser_ID || "";
    var Place_Id = dl_data?.Place_Id || "";

    var Meta_Title = dl_data?.Meta_Title || "";
    var Meta_Image = dl_data?.Meta_Image || "";
    var Meta_Description = dl_data?.Meta_Description || "";

    //Meta_Description = encodeURIComponent(Meta_Description);

    // Push_Type=9
    // &Post_ID=45463
    // &Deep_Link_URI=5e6zr4rrlwucyvx8k
    // &User_TokenKey=g7j5vaqjas58qqbzelvatx25n1713782611498
    // &User_ID=1689
    // &Ads_ID=
    // &Advertiser_ID=
    // &Place_Id=    

    // "User_ID": "6",
    // "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e",
    // "Deep_Link_URI": "no0awkvxatlx8gmxz",
    // "Push_Type": "1",
    // "Meta_Title": "Dr. Nigam Kr tiwari",
    // "Meta_Image": "1756968728097.jpg",
    // "Meta_Description": "Contact%20us%3A-%208800530116%20%2C%20deekshaojha15%40gmail.com%20%20website%3A-%20www.explurger.com",    

    // const deepLinkParams = "Deep_Link_URI="+Deep_Link_URI;
    // const encodedParams = encodeURIComponent(deepLinkParams);

    // const deepLinkParams = "deeplink=true&Push_Type=<%=data.Push_Type%>&Post_ID=<%=data.Post_ID%>&Deep_Link_URI=<%=data.Deep_Link_URI%>&User_TokenKey=<%=data.User_TokenKey%>&User_ID=<%=data.User_ID%>&Ads_ID=<%=data.Ads_ID%>&Advertiser_ID=<%=data.Advertiser_ID%>&Place_Id=<%=data.Place_Id%>&Meta_Title=<%=data.Meta_Title%>&Meta_Description=<%=data.Meta_Description%>&Meta_Image=<%=data.Meta_Image%>";    

    // const deepLinkParams = "deeplink=true&Push_Type=<%=data.Push_Type%>&Post_ID=<%=data.Post_ID%>&Deep_Link_URI=<%=data.Deep_Link_URI%>&User_TokenKey=<%=data.User_TokenKey%>&User_ID=<%=data.User_ID%>&Ads_ID=<%=data.Ads_ID%>&Advertiser_ID=<%=data.Advertiser_ID%>&Place_Id=<%=data.Place_Id%>";    

    const deepLinkParams = "deeplink=true&Push_Type="+Push_Type+"&Post_ID="+Post_ID+"&Deep_Link_URI="+Deep_Link_URI+"&User_TokenKey="+User_TokenKey+"&User_ID="+User_ID+"&Ads_ID="+Ads_ID+"&Advertiser_ID="+Advertiser_ID+"&Place_Id="+Place_Id+"&Meta_Title="+Meta_Title+"&Meta_Description="+Meta_Description+"&Meta_Image="+Meta_Image;


    const encodedParams = decodeURIComponent(deepLinkParams);     
    
    // console.log("Apple URL ", Deep_Link_URI, browserType);
    // console.log("Apple fallbackUrl ", deepLinkParams, _fallbackURL);     

    var deepLinkUrl = getIOSDDLURL(browserType, encodedParams);

    //alert(deepLinkUrl);

    // if (browserType == "Apple Safari") {
    //   //var deepLinkUrl = APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Safari
    //   //deepLinkUrl = constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Safari
    //   //deepLinkUrl = getIOSDDLURL(browserType, encodedParams);
    //   //deepLinkUrl = appScheme;
    //   console.log("Apple URL Safari-deepLinkUrl: ", deepLinkUrl);
    //   //window.location.href = deepLinkUrl;
    //   openDeepLink(deepLinkUrl);
    //   // if (dlAppOpen == 0) {
    //   //   window.location.href = deepLinkUrl;
    //   // }
    //   //var dl_status = 0;
    //   const timeoutId = setTimeout(function () {
    //     //alert(document.visibilityState);

    //       console.log("Apple URL -_fallbackURL: ", _fallbackURL);
    //       //window.location.href = _fallbackURL; 
    //       openDeepLink(_fallbackURL);       

    //   }, 1500); // 1 sec 
      
    //   // const startTime = Date.now();

    //   // // Attempt to open the app via an invisible iframe
    //   // const iframe = document.createElement('iframe');
    //   // iframe.style.display = 'none';
    //   // iframe.src = deepLinkUrl;
    //   // document.body.appendChild(iframe);

    //   // // Fallback after 1.5 seconds if app didn't open
    //   // setTimeout(function () {
    //   //   const elapsed = Date.now() - startTime;
    //   //   if (elapsed < 2000) { // App likely not installed
    //   //     openDeepLink(_fallbackURL);
    //   //   }
    //   // }, 1500);

    // } else {
    //   //var deepLinkUrl = "com.veensa.Explurger-iOS://" + APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Chrome & Others
    //   //deepLinkUrl = appScheme;
    //   //deepLinkUrl = "com.veensa.Explurger-iOS://" + constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Chrome & Others
    //   //deepLinkUrl = getIOSDDLURL(browserType, encodedParams);
    //   console.log("Apple URL -2 -deepLinkUrl: ", deepLinkUrl);
    //   //window.location.href = deepLinkUrl;
    //   openDeepLink(deepLinkUrl);
    //   // if (dlAppOpen == 0) {
    //   //   window.location.href = deepLinkUrl;
    //   // }
    //   //var dl_status = 0;
    //   const timeoutId = setTimeout(function () {
    //     //alert(document.visibilityState);
    //       console.log("Apple URL -2 -_fallbackURL: ", _fallbackURL);
    //       //window.location.href = _fallbackURL;
    //       openDeepLink(_fallbackURL); 
    //   }, 1500); // 1 sec 
    // } 

    var deepLinkUrlIos = "com.veensa.Explurger-iOS://" + constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Chrome & Others    

    //console.log(" deepLinkUrlIos, browserType ", deepLinkUrlIos, browserType);

    //$("#myInput").val(data);
    document.getElementById("myInput").value = deepLinkUrlIos;

    // Get the text field
    var copyText = document.getElementById("myInput");

    //console.log(" deepLinkUrlIos, copyText ", copyText, copyText.value);

    // Select the text field
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices

    //console.log(" deepLinkUrlIos, copyText ", copyText, copyText.value);
    // Copy the text inside the text field
    //navigator.clipboard.writeText(copyText.value);

    navigator.clipboard.writeText(copyText.value)
      .then(() => console.log("Copied!"))
      .catch(err => console.error("Copy failed:", err));       
    
    //console.log(" deepLinkUrl, browserType ", deepLinkUrl, browserType);
    
    if (browserType == "Apple Safari") {
      //var deepLinkUrl = Deep_Link_Base_Url + "/ddl/index.html?" + encodedParams; // Safari
      if (dlAppOpen == 0) {

        //window.location.href = deepLinkUrl;        
        if (window.top !== window.self) 
        {
          window.parent.postMessage({ action: "openDeepLink", dl_url: deepLinkUrl }, "*");
        }
        else
        {
          window.location.href = deepLinkUrl;
        }        
        // if (window.top !== window.self)
        //   window.top.location.href = deepLinkUrl;
        // else
        //   window.location.href = deepLinkUrl;
      }
      var dl_status = 0;
      // const timeoutId = setTimeout(function () {
      //   //alert(document.visibilityState);
      //   document.addEventListener('visibilitychange', () => {
      //     if (document.visibilityState === 'hidden') {
      //       // alert("Hello!");
      //       dl_status = 1;
      //       dlAppOpenStatus = 1;
      //       //clearTimeout(timeoutId);
      //     } else {
      //       // && window.location.href !==deepLinkUrl
      //       if (dl_status == 0 && dlAppOpenStatus == 0) {
      //         dlAppOpen = 1;
      //         //window.location.href = _fallbackURL;
      //         window.parent.postMessage({ action: "openDeepLink", dl_url: _fallbackURL }, "*");
      //       }
      //     }
      //   });
      // }, 1500); // 1 sec 
    } else {
      //var deepLinkUrl = "com.veensa.Explurger-iOS://" + Deep_Link_Base_Url + "/ddl/index.html?" + encodedParams; // Chrome & Others
      if (dlAppOpen == 0) {
        //window.location.href = deepLinkUrl;        
        if (window.top !== window.self) 
        {
          window.parent.postMessage({ action: "openDeepLink", dl_url: deepLinkUrl }, "*");
        }
        else
        {
          window.location.href = deepLinkUrl;
        }
        // if (window.top !== window.self)
        //   window.top.location.href = deepLinkUrl;
        // else
        //   window.location.href = deepLinkUrl;
      }
      var dl_status = 0;
      // const timeoutId = setTimeout(function () {
      //   //alert(document.visibilityState);
      //   //document.addEventListener('visibilitychange', () => {
      //   if (document.visibilityState === 'hidden') {
      //     // alert("Hello!");
      //     dl_status = 1;
      //     dlAppOpenStatus = 1;
      //     //clearTimeout(timeoutId);
      //   } else {
      //     // && window.location.href !==deepLinkUrl
      //     if (dl_status == 0 && dlAppOpenStatus == 0) {
      //       dlAppOpen = 1;
      //       //window.location.href = _fallbackURL;
      //       window.parent.postMessage({ action: "openDeepLink", dl_url: _fallbackURL }, "*");
      //     }
      //   }
      //   //});
      // }, 1500); // 1 sec 
    }    
};

const openAppOrStoreIOSOld = (_fallbackURL="") => {
    const browserType = getBrowserType();
    var dlAppOpenStatus = 0;
    var dlAppOpen = 0;    

    //var pathNames = window.location.pathname.split("/");
    //var mid = pathNames[1];
    //var Deep_Link_URI = pathNames[2];

    // var profile_data = getLocalStorage("profile_data");

    // console.log("profile_data", profile_data);    

    // const deepLinkParams = "Deep_Link_URI="+Deep_Link_URI;
    // const encodedParams = encodeURIComponent(deepLinkParams);

    var dl_data = getLocalStorage("DL_Meta_Data");

    //console.log("dl_data", dl_data);

    var Push_Type = dl_data?.Push_Type || "";
    var Post_ID = dl_data?.Post_ID || "";
    var Deep_Link_URI = dl_data?.Deep_Link_URI || "";
    var User_TokenKey = dl_data?.User_TokenKey || "";
    var User_ID = dl_data?.User_ID || "";

    var Ads_ID = dl_data?.Ads_ID || "";
    var Advertiser_ID = dl_data?.Advertiser_ID || "";
    var Place_Id = dl_data?.Place_Id || "";

    var Meta_Title = dl_data?.Meta_Title || "";
    var Meta_Image = dl_data?.Meta_Image || "";
    var Meta_Description = dl_data?.Meta_Description || "";

    Meta_Description = encodeURIComponent(Meta_Description);

    // Push_Type=9
    // &Post_ID=45463
    // &Deep_Link_URI=5e6zr4rrlwucyvx8k
    // &User_TokenKey=g7j5vaqjas58qqbzelvatx25n1713782611498
    // &User_ID=1689
    // &Ads_ID=
    // &Advertiser_ID=
    // &Place_Id=    

    // "User_ID": "6",
    // "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e",
    // "Deep_Link_URI": "no0awkvxatlx8gmxz",
    // "Push_Type": "1",
    // "Meta_Title": "Dr. Nigam Kr tiwari",
    // "Meta_Image": "1756968728097.jpg",
    // "Meta_Description": "Contact%20us%3A-%208800530116%20%2C%20deekshaojha15%40gmail.com%20%20website%3A-%20www.explurger.com",    

    // const deepLinkParams = "Deep_Link_URI="+Deep_Link_URI;
    // const encodedParams = encodeURIComponent(deepLinkParams);

    // const deepLinkParams = "deeplink=true&Push_Type=<%=data.Push_Type%>&Post_ID=<%=data.Post_ID%>&Deep_Link_URI=<%=data.Deep_Link_URI%>&User_TokenKey=<%=data.User_TokenKey%>&User_ID=<%=data.User_ID%>&Ads_ID=<%=data.Ads_ID%>&Advertiser_ID=<%=data.Advertiser_ID%>&Place_Id=<%=data.Place_Id%>&Meta_Title=<%=data.Meta_Title%>&Meta_Description=<%=data.Meta_Description%>&Meta_Image=<%=data.Meta_Image%>";    

    // const deepLinkParams = "deeplink=true&Push_Type=<%=data.Push_Type%>&Post_ID=<%=data.Post_ID%>&Deep_Link_URI=<%=data.Deep_Link_URI%>&User_TokenKey=<%=data.User_TokenKey%>&User_ID=<%=data.User_ID%>&Ads_ID=<%=data.Ads_ID%>&Advertiser_ID=<%=data.Advertiser_ID%>&Place_Id=<%=data.Place_Id%>";    

    const deepLinkParams = "deeplink=true&Push_Type="+Push_Type+"&Post_ID="+Post_ID+"&Deep_Link_URI="+Deep_Link_URI+"&User_TokenKey="+User_TokenKey+"&User_ID="+User_ID+"&Ads_ID="+Ads_ID+"&Advertiser_ID="+Advertiser_ID+"&Place_Id="+Place_Id+"&Meta_Title="+Meta_Title+"&Meta_Description="+Meta_Description+"&Meta_Image="+Meta_Image;


    const encodedParams = decodeURIComponent(deepLinkParams);     
    
    // console.log("Apple URL ", Deep_Link_URI, browserType);
    // console.log("Apple fallbackUrl ", deepLinkParams, _fallbackURL);     

    var deepLinkUrl = getIOSDDLURL(browserType, encodedParams);
    if (browserType == "Apple Safari") {
      //var deepLinkUrl = APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Safari
      //deepLinkUrl = constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Safari
      //deepLinkUrl = getIOSDDLURL(browserType, encodedParams);
      //deepLinkUrl = appScheme;
      //console.log("Apple URL Safari-deepLinkUrl: ", deepLinkUrl);
      if (dlAppOpen == 0) {
        window.location.href = deepLinkUrl;
      }
      var dl_status = 0;
      const timeoutId = setTimeout(function () {
        //alert(document.visibilityState);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            // alert("Hello!");
            dl_status = 1;
            dlAppOpenStatus = 1;
            //clearTimeout(timeoutId);
          } else {
            // && window.location.href !==deepLinkUrl
            if (dl_status == 0 && dlAppOpenStatus == 0) {
              dlAppOpen = 1;
              //console.log("Apple URL -_fallbackURL: ", _fallbackURL);
              window.location.href = _fallbackURL;
                           
            }
          }
        });
      }, 1500); // 1 sec 
    } else {
      //var deepLinkUrl = "com.veensa.Explurger-iOS://" + APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Chrome & Others
      //deepLinkUrl = appScheme;
      //deepLinkUrl = "com.veensa.Explurger-iOS://" + constants.APP_DEEP_LINK_BASE_URL + "/ddl/index.html?" + encodedParams; // Chrome & Others
      //deepLinkUrl = getIOSDDLURL(browserType, encodedParams);
      //console.log("Apple URL -2 -deepLinkUrl: ", deepLinkUrl);
      if (dlAppOpen == 0) {
        window.location.href = deepLinkUrl;
      }
      var dl_status = 0;
      const timeoutId = setTimeout(function () {
        //alert(document.visibilityState);
        //document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          // alert("Hello!");
          dl_status = 1;
          dlAppOpenStatus = 1;
          //clearTimeout(timeoutId);
        } else {
          // && window.location.href !==deepLinkUrl
          if (dl_status == 0 && dlAppOpenStatus == 0) {
            dlAppOpen = 1;
            //console.log("Apple URL -2 -_fallbackURL: ", _fallbackURL);
            window.location.href = _fallbackURL;              
          }
        }
        //});
      }, 1500); // 1 sec 
    }    
};
const openAppOrStore = () => {
    var FallbackURL = constants.APP_WEBSITE_URL;
    //var FallbackURL = constants.APP_DEEP_LINK_BASE_URL +  window.location.pathname;

    //console.log("FallbackURL", FallbackURL);

    if((isMobile || isTablet) && isAndroid)
    {
        FallbackURL = constants.APP_GOOGLE_PLAY_URL;
    }
    else if((isMobile || isTablet) && isIOS)
    {
        FallbackURL = constants.APP_APPLE_APP_STORE_URL;
    }
    
    if((isMobile || isTablet) && isAndroid)
    {
        openAppOrStoreAndroid(FallbackURL);
    }
    else if((isMobile || isTablet) && isIOS)
    {
        openAppOrStoreIOS(FallbackURL);
    }
    else
    {
        //window.open(url);
        //window.location.replace(FallbackURL);
        //console.log("WEBSITE URL -FallbackURL: ", FallbackURL);
        //window.location.href = FallbackURL; 

        // try {
        //   // If we are inside an iframe, redirect the top window
        //   if (window.top !== window.self) {
        //     console.log("WEBSITE URL-window.top -FallbackURL: ", FallbackURL);
        //     window.top.location.href = FallbackURL;
        //   } else {
        //     console.log("WEBSITE URL-Not inside an iframe -FallbackURL: ", FallbackURL);
        //     // Not inside an iframe, just change current window location
        //     window.location.href = FallbackURL;
        //   }
        // } catch (e) {
        //   // If cross-origin prevents access to window.top, fallback to normal redirect
        //   console.log(e);
        //   window.location.href = FallbackURL;
        // }

        openDeepLink(FallbackURL);

    }
};

// const openURL = (_URL="") => {
//         console.log("WEBSITE URL -FallbackURL: ", FallbackURL);
//         //window.location.href = FallbackURL; 

//         try {
//           // If we are inside an iframe, redirect the top window
//           if (window.top !== window.self) {
//             console.log("WEBSITE URL-window.top -FallbackURL: ", FallbackURL);
//             window.top.location.href = FallbackURL;
//           } else {
//             console.log("WEBSITE URL-Not inside an iframe -FallbackURL: ", FallbackURL);
//             // Not inside an iframe, just change current window location
//             window.location.href = FallbackURL;
//           }
//         } catch (e) {
//           // If cross-origin prevents access to window.top, fallback to normal redirect
//           console.log(e);
//           window.location.href = FallbackURL;
//         }
// };

function openDeepLink(_URL) {
  //console.log("openDeepLink-WEBSITE URL -_URL: ", _URL);
  if (window.top !== window.self) 
  {
    window.parent.postMessage({ action: "openDeepLink", dl_url: _URL }, "*");
  }
  else
  {
    window.location.href = _URL;
  }
  
  // try {
  //   // Check if we are inside an iframe
  //   if (window.top !== window.self) {
  //     console.log("openDeepLink-Navigate from top window -_URL: ", _URL);
  //     // Navigate from top window (breaks out of iframe)
  //     window.location.href = _URL;
  //     // if(isSafari)
  //     //   window.location.href = _URL;
  //     // else
  //     //   window.top.location.href = _URL;
  //   } else {
  //     // Normal navigation
  //     console.log("openDeepLink-Normal navigation -_URL: ", _URL);
  //     window.location.href = _URL;
  //   }
  // } catch (err) {
  //   // Fallback in case window.top access is blocked (rare)
  //   console.error("openDeepLink-catch", err);
  //   window.location.href = _URL;
  // }
}


export { 
    openAppOrStore
};